import React from 'react';
import { Link } from 'react-router-dom';

// Footer navigation links
const footerLinks = {
  company: [
    { label: 'About', href: '/about', isPage: true },
    { label: 'Our Method', href: '#method', isPage: false },
    { label: 'History', href: '/history', isPage: true },
    { label: 'Contact', href: '/contact', isPage: true },
  ],
  explore: [
    { label: 'Our Brands', href: '/brands', isPage: true },
    { label: 'Showroom', href: '/showroom', isPage: true },
  ],
  legal: [
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms of Service', href: '#' },
  ],
};

const Footer = () => {
  const handleHashClick = (e, hash) => {
    e.preventDefault();
    const element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      // If not on home page, navigate to home page with hash
      window.location.href = '/' + hash;
    }
  };

  return (
    <footer className="bg-[#0a0a0a] py-16 px-6 border-t border-white/[0.06]">
      <div className="max-w-[1320px] mx-auto">
        {/* Main footer grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-5">
              <img
                src="/logos-for-web/LV1GROUP.png"
                alt="LV1 Group"
                className="h-auto object-contain w-[140px] hover:brightness-110 transition-all duration-300"
              />
            </Link>
            <p className="text-[#6a6a6a] text-[14px] leading-[1.7] mb-6">
              A family-built footwear company established in 1983, operating a portfolio of owned and licensed brands.
            </p>
            <p className="text-[#6a6a6a] text-[14px]">
              info@lv1group.com
            </p>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-medium text-[14px] mb-5">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  {link.isPage ? (
                    <Link
                      to={link.href}
                      className="text-[#6a6a6a] text-[14px] hover:text-white transition-colors duration-300"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      onClick={(e) => handleHashClick(e, link.href)}
                      className="text-[#6a6a6a] text-[14px] hover:text-white transition-colors duration-300"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Explore Links */}
          <div>
            <h4 className="text-white font-medium text-[14px] mb-5">Explore</h4>
            <ul className="space-y-3">
              {footerLinks.explore.map((link) => (
                <li key={link.label}>
                  {link.isPage ? (
                    <Link
                      to={link.href}
                      className="text-[#6a6a6a] text-[14px] hover:text-white transition-colors duration-300"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-[#6a6a6a] text-[14px] hover:text-white transition-colors duration-300"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-white font-medium text-[14px] mb-5">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-[#6a6a6a] text-[14px] hover:text-white transition-colors duration-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/[0.06]">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-[#6a6a6a] text-[13px]">
              &copy; {new Date().getFullYear()} LV1 Group. All rights reserved.
            </p>
            <p className="text-[#6a6a6a] text-[13px]">
              Established 1983 &middot; New Jersey, USA
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
